import React from "react";
import { Link } from "react-router-dom";
import "./WhoWeAre.css";

/**
 * Props:
 *  - imageSrc (optional): path to the right-side image.
 *    Defaults to /mng-ownerone.jpg in /public.
 */
export default function WhoWeAre({ imageSrc }) {
  const IMG = imageSrc || `${process.env.PUBLIC_URL}/mng-ownerone.jpg`;

  return (
    <section className="wwa" aria-labelledby="wwa-title">
      <div className="wwa__container">
        {/* Content panel - left */}
        <article className="wwa__panel">
          <div className="wwa__header">
            <span className="wwa__badge">OUR STORY</span>
            <h2 id="wwa-title" className="wwa__title">
              Building Excellence, Forging Legacy
            </h2>
            <div className="wwa__accent-line"></div>
          </div>

          <div className="wwa__content">
            <div className="wwa__text-group">
              <h3 className="wwa__eyebrow">WHO WE ARE</h3>

              <div className="wwa__copy">
                <p className="wwa__lead">
                  MNG has its roots on the West Coast. Two experienced
                  construction professionals founded MNG. One member is a
                  Black American, Mohamed Moalin, who grew up in the local
                  Seattle area. Mohamed holds a Bachelor of Science in
                  Civil Engineering from Washington State University.
                </p>

                <p>
                  The other is a descendant of the local tribe, Greg Qualls,
                  who grew up dairy farming in Enumclaw, WA, and joined
                  the local 302 operators' union at 18. He has been working
                  and growing in the construction field for over two decades.
                  Together, Mohamed and Greg started MNG Construction in 2019
                  and grew the company into what it is today.
                </p>

                <p>
                  MNG is a certified DBE/MBE/SCS/SBA. MNG is a signatory
                  with both Laborers and Operators unions and a member of
                  the Associated General Contractors of America.
                </p>
              </div>
            </div>

            {/* CTA */}
            <div className="wwa__cta">
              <Link to="/about-us" className="wwa__btn" aria-label="Go to About Us page">
                About Us
                <svg width="18" height="18" viewBox="0 0 20 20" aria-hidden="true">
                  <path d="M7.5 5L12.5 10L7.5 15" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </Link>
            </div>
          </div>
        </article>

        {/* Image panel - right (height matches left column) */}
        <figure className="wwa__media">
          <div className="wwa__image-container">
            <img
              src={IMG}
              alt="MNG dump truck with crew on site"
              className="wwa__image"
              loading="lazy"
              decoding="async"
            />
            <div className="wwa__image-overlay"></div>
          </div>

          <figcaption className="wwa__image-caption">
            <div className="wwa__caption-badge">
              <span>Since 2019</span>
            </div>
          </figcaption>
        </figure>
      </div>
    </section>
  );
}
